import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { SegmentLegacyComponent } from './segment.component';

@NgModule({
  entryComponents: [
    SegmentLegacyComponent
  ],
  declarations: [
    SegmentLegacyComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule
  ],
  exports: [
    SegmentLegacyComponent
  ]
})
export class SegmentLegacyModule {}
